import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'antd';

const CustomFilterPanelHeader = ({ text, list }) => {
  return (
    <span>
      {text}{' '}
      {list?.length > 0 ? (
        <Badge count={list?.length} style={{ backgroundColor: '#f5222d' }} />
      ) : null}
    </span>
  );
};

// PropTypes tanımlaması
CustomFilterPanelHeader.propTypes = {
  text: PropTypes.string,
  list: PropTypes.array,
};

export default CustomFilterPanelHeader;
